import React, { useState, useRef } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Box, Checkbox, FormControlLabel
} from "@mui/material";

const TermsModal = ({ open, onClose, onAgree }) => {
  const [scrolledToBottom, setScrolledToBottom] = useState(false);
  const [checked, setChecked] = useState(false);
  const contentRef = useRef(null);

  const handleScroll = () => {
  const el = contentRef.current;
  if (!el) return;

  const threshold = 10; // 10px以内なら許容
  const reachedBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - threshold;

  if (reachedBottom) {
    setScrolledToBottom(true);
  }
};

  const termsHtml = `
  <h2>【SupplyAssist 利用規約】</h2>
  <p>この利用規約（以下「本規約」といいます）は、SupplyAssist（以下「本サービス」といいます）を提供する事業者（以下「当社」といいます）と、本サービスをご利用いただくすべての利用者（以下「ユーザー」といいます）との間の権利義務関係を定めるものです。本サービスの利用に際しては、本規約に同意いただいたものとみなします。</p>
  <p><strong>第1条（適用）</strong> 本規約は、ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されます。</p>
  <p><strong>第2条（提供サービスの内容）</strong> 本サービスは、主に運送・配送業者向けに、配達管理・顧客管理・供給履歴の記録などをクラウド上で提供する業務支援ツールです。スマートフォン・PCなどのブラウザ環境から利用可能です。</p>
  <p><strong>第3条（登録とアカウント）</strong><br/>
  ユーザーは、Googleアカウントによるログイン等、当社が指定する方法により利用登録を行うものとします。<br/>
  ユーザーは、アカウント情報を自己の責任で管理するものとし、第三者による不正使用について当社は責任を負いません。</p>
  <p><strong>第4条（料金・プラン）</strong><br/>
  本サービスは、無料プランおよび有料プランを提供します。<br/>
  有料プランの料金、機能制限、支払方法等は当社の定めるとおりとします。<br/>
  ユーザーが有料プランに申込み、Stripeなどの決済手段で支払いを完了した時点で契約が成立します。</p>
  <p><strong>第5条（禁止事項）</strong> ユーザーは、以下の行為を行ってはなりません：<br/>
  ・法令または公序良俗に反する行為<br/>
  ・本サービスの運営を妨げる行為<br/>
  ・他のユーザーまたは第三者に不利益や損害を与える行為<br/>
  ・不正アクセスや改ざんなどのセキュリティを脅かす行為</p>
  <p><strong>第6条（サービスの停止・変更）</strong> 当社は、事前の通知なくして本サービスの全部または一部を停止・変更することがあります。これによりユーザーに生じた損害について、当社は一切の責任を負いません。</p>
  <p><strong>第7条（解約・返金）</strong><br/>
  ユーザーはいつでも有料プランを解約することができます。<br/>
  月の途中で解約された場合でも、日割り返金等は行いません。</p>
  <p><strong>第8条（免責事項）</strong><br/>
  本サービスは、現状有姿で提供されるものであり、当社はその正確性・完全性・有用性について保証しません。<br/>
  本サービスの利用により発生した損害について、当社は一切の責任を負いません。</p>
  <p><strong>第9条（準拠法・裁判管轄）</strong> 本規約は日本法に準拠し、本サービスに関する紛争は当社の所在地を管轄する裁判所を第一審の専属的合意管轄裁判所とします。</p>
  <p><strong>【お問い合わせ先】</strong><br/>メールアドレス：hirotoisogawa@gmail.com<br/>
  運営者：五十川 大翔</p>

  <h2>【SupplyAssist プライバシーポリシー】</h2>
  <p>SupplyAssist（以下「本サービス」といいます）は、利用者の皆様（以下「ユーザー」といいます）の個人情報を適切に保護・管理することを重要な責務と認識し、以下のとおりプライバシーポリシー（以下「本ポリシー」といいます）を定めます。</p>
  <p><strong>第1条（取得する情報）</strong><br/>
  氏名、メールアドレス、Googleアカウント情報等、ログインに必要な認証情報<br/>
  顧客情報や供給履歴など、ユーザーが自発的に登録する業務データ<br/>
  利用環境（ブラウザ情報、アクセス元IPアドレス等）</p>
  <p><strong>第2条（利用目的）</strong><br/>
  ・本サービスの提供・改善・安定運用のため<br/>
  ・問い合わせ対応、ユーザーサポートのため<br/>
  ・利用動向の分析や新機能の開発のため<br/>
  ・必要に応じたご連絡や通知のため</p>
  <p><strong>第3条（第三者提供）</strong><br/>
  以下の場合を除き、ユーザーの同意なく第三者に個人情報を提供いたしません：<br/>
  ・法令に基づく場合<br/>
  ・人の生命、身体または財産の保護に必要がある場合<br/>
  ・公的機関（裁判所・警察等）からの正式な要請がある場合<br/>
  ・業務委託先への委託（例：決済処理、サーバー管理等）</p>
  <p><strong>第4条（外部サービスとの連携）</strong><br/>
  Googleログイン、Stripe決済等の外部サービスと連携する場合があります。取得情報の取り扱いは各提供元のポリシーに従います。</p>
  <p><strong>第5条（安全管理）</strong><br/>
  当社は不正アクセス・漏洩・紛失等を防ぐために適切なセキュリティ対策を講じます。</p>
  <p><strong>第6条（ユーザーによる管理）</strong><br/>
  ユーザーは登録情報の確認・修正・削除を、管理画面やサポート問い合わせにより行うことができます。</p>
  <p><strong>第7条（ポリシーの変更）</strong><br/>
  必要に応じて予告なく変更されることがあります。重要な変更はウェブサイト等でお知らせいたします。</p>
  <p><strong>【お問い合わせ先】</strong><br/>メールアドレス：hirotoisogawa@gmail.com<br/>
  運営者：五十川 大翔</p>
`;


  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>利用規約およびプライバシーポリシー</DialogTitle>
      <DialogContent
        dividers
        onScroll={handleScroll}
        ref={contentRef}
        sx={{ maxHeight: "400px", overflowY: "auto" }}
      >
        <Box dangerouslySetInnerHTML={{ __html: termsHtml }} />
      </DialogContent>

      <Box px={3} pt={1}>
        <FormControlLabel
          control={
            <Checkbox
              checked={checked}
              onChange={(e) => setChecked(e.target.checked)}
              disabled={!scrolledToBottom}
            />
          }
          label="利用規約およびプライバシーポリシーに同意します"
        />
      </Box>

      <DialogActions>
        <Button onClick={onClose}>キャンセル</Button>
        <Button
          onClick={onAgree}
          disabled={!scrolledToBottom || !checked}
          variant="contained"
          color="primary"
        >
          同意して進む
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TermsModal;
